// IE 2026 10 18 / ODOO-5800 (Igor, п. 3–4: M03 WIDGET-REPORT2 0fU_001 / 1coh_001 возвращён 18.10 на схему флажков — политики согласования у сегмента 0GJ_001 нет,
// doc._approval не приходит, и фронт потерял (а) птички «частично / все ✓» на строках-итогах групп и (б) не умеет каскад флажка по измерениям шага):
// чистая логика без Vue и wijmo (юнит — tests/unit/m03Flags.test.mjs) для двух вещей, которые AttrGrid делает по строкам грида в памяти, без бэка:
//   1. колонки флажков M03 БЕЗ политики: поля шагов ApprovedPM → ApprovedBUM → ApprovedMD (порядок = порядок шагов) по привязкам колонок грида
//      (data::ApprovedPM / data.… / doc.data.…) — ими живёт прежний живой итог «частично / все ✓» utils/approval.js (approvalPartialLive*, 14.10, коммиты
//      ec9af404f → 4b3835481 → a82414865 → 002ef2bf5), который брал колонки только из шагов политики (approvalFlagBindings) и без неё молчал;
//   2. каскад при УСТАНОВКЕ флажка: БЮМ → ApprovedBUM на все загруженные строки-документы с теми же doc.БЮ + doc.Бренд + doc.Страна (БиТ_Регионы документа
//      M03, work."records-0GJ_001-<версия>": ключи doc — БЮ, Бренд, Сводная Номенклатура, Страна, Канал продаж), без учёта Сводной Номенклатуры;
//      МД → ApprovedMD на все загруженные строки-документы того же doc.БЮ (Igor: «для МД — на всех строках без учёта Бит_регионы»). ПМ — без каскада.
//      Строка-документ — строка с _DLRow.record_id и тем же ключом отбора _DLRow.where (мера + год: LBE 2026 ≠ STR 2028), самая глубокая по record_id
//      (как у живого итога); измерение, которого в строке нет (undefined — колонка не загружена в отчёт), не различает строки (missingDims — для журнала).
//      Снятие флажка — только своя строка. Порядок шагов (fe.ux.m03CascadeOrder, дефолт ВКЛ): флажок шага k ставится каскадом только там, где стоят
//      флажки шагов ниже (lower), — иначе pre_write бэка отказал бы всему Save.
// Выключатели: fe.ux.m03FlagsLocal (всё; дефолт ВКЛ — выкл: как до правки, без политики ни итогов, ни каскада), fe.ux.m03Cascade (каскад; дефолт ВКЛ),
// fe.ux.m03CascadeOrder (порядок шагов в каскаде; дефолт ВКЛ). Крючки — AttrGrid.vue: approvalPartial_cols (fallback колонок), set_value → m03Flags_afterEdit.
import { approvalRowKey, approvalPartialLive } from './approval'
// выключатель fe.ux.m03FlagsLocal, поля шагов и поле по привязке — общие с картой шагов без политики (PR #127, utils/m03FlagsLocal.js): одно определение
import { M03_FLAGS_LOCAL_FLAG, m03FlagsLocal_on, M03_FLAG_FIELDS, m03FlagField } from './m03FlagsLocal'
export { M03_FLAG_FIELDS, m03FlagField }

export const M03_FLAGS_FLAG = M03_FLAGS_LOCAL_FLAG
export const M03_CASCADE_FLAG = 'fe.ux.m03Cascade'
export const M03_CASCADE_ORDER_FLAG = 'fe.ux.m03CascadeOrder'

const isObj = (x) => !!x && typeof x === 'object' && !Array.isArray(x)
const has = (x) => x !== undefined && x !== null && x !== ''
const str = (x) => (x === undefined || x === null) ? '' : String(x)
const onOf = (flag) => (setting) => { try { return typeof setting !== 'function' || setting(flag, true) !== false } catch (e) { return true } }

// setting — функция (key, default) → значение; нет функции / ошибка — ВКЛ
export const m03FlagsLocalOn = m03FlagsLocal_on
export const m03CascadeOn = onOf(M03_CASCADE_FLAG)
export const m03CascadeOrderOn = onOf(M03_CASCADE_ORDER_FLAG)
// измерения каскада по полю шага: null — каскада нет (ПМ)
export const M03_CASCADE_DIMS = {
    ApprovedBUM: ['doc.БЮ', 'doc.Бренд', 'doc.Страна'],
    ApprovedMD: ['doc.БЮ'],
}
// номер шага привязки 1..3; 0 — не флажок M03
export function m03FlagStep(binding) {
    const f = m03FlagField(binding)
    return f ? M03_FLAG_FIELDS.indexOf(f) + 1 : 0
}
// привязки колонок флажков M03 из списка привязок грида, по порядку шагов
export function m03FlagBindings(bindings) {
    if (!Array.isArray(bindings)) return []
    const out = bindings.filter(b => m03FlagStep(b) > 0)
    out.sort((a, b) => m03FlagStep(a) - m03FlagStep(b))
    return out.filter((b, i) => out.indexOf(b) === i)
}
// привязки шагов НИЖЕ шага binding среди cols (порядок каскада)
export function m03LowerBindings(binding, cols) {
    const k = m03FlagStep(binding)
    if (!k || !Array.isArray(cols)) return []
    return cols.filter(b => { const s = m03FlagStep(b); return s > 0 && s < k })
}
// IE 2026 10 18 / ODOO-5800 (Igor, каскад СИММЕТРИЧНЫЙ): привязки шагов ВЫШЕ шага binding среди cols — при снятии каскадом цель с поставленным флажком выше не трогается (она заперта им)
export function m03UpperBindings(binding, cols) {
    const k = m03FlagStep(binding)
    if (!k || !Array.isArray(cols)) return []
    return cols.filter(b => m03FlagStep(b) > k)
}
// измерения каскада для привязки флажка; null — каскада нет
export function m03CascadeDims(binding) {
    const f = m03FlagField(binding)
    const d = f ? M03_CASCADE_DIMS[f] : null
    return Array.isArray(d) && d.length ? d.slice() : null
}
// значение флажка истинно (как у живого итога: true / 1 / 'true' / {value})
export function m03FlagTrue(v) {
    if (isObj(v)) v = v.value
    if (typeof v === 'string') return ['true', '1', 'yes', 'on'].includes(v.trim().toLowerCase())
    return v === true || v === 1
}
// нормализованное значение измерения для сравнения: ссылка {id} / {value} → id; скаляр → строка; undefined — «нет поля»
export function m03DimValue(v) {
    if (v === undefined) return undefined
    if (v === null) return ''
    if (isObj(v)) { const x = has(v.id) ? v.id : (has(v.value) ? v.value : (has(v.valueStr) ? v.valueStr : null)); return x === null ? JSON.stringify(v) : str(x) }
    return str(v)
}
const TAB_KINDS = ['tab', 'tabrow', 'tabcol', 'tabheader']
const skipRow = (x) => !isObj(x) || !!x._variant || (isObj(x._DLRow) && (TAB_KINDS.includes(str(x._DLRow.row_type)) || !!x._DLRow.memo))
const recId = (x) => (isObj(x) && isObj(x._DLRow) && has(x._DLRow.record_id)) ? x._DLRow.record_id : null
const lvl = (r) => { const n = Number(r && r.level); return Number.isFinite(n) ? n : 0 }

// IE 2026 10 18 / ODOO-5800 (Igor: «каскад должен быть СИММЕТРИЧНЫМ»): opts.clear — каскад при СНЯТИИ флажка: те же цели (измерения шага, ключ меры / года, строки-документы),
// но снимаются те, где флажок стоит; opts.upper — привязки шагов выше, которые НЕ должны стоять у цели (зеркало lower). Снятие верхнего флажка нижние не трогает (МД снят — БЮМ остаётся).
// Строки-цели каскада при установке флажка binding у строки rows[irow]. rows — строки грида по порядку ({level, dataItem}: wijmo RowCollection либо массив —
// только length и индекс), read(dataItem, binding) — живое значение (несохранённое тоже). opts: dims (по умолчанию — m03CascadeDims(binding)),
// lower — привязки шагов ниже, которые должны стоять у цели (порядок), canSet(dataItem, irow) — дополнительный отказ (замок бэка).
// → { targets: [{irow, dataItem}], missingDims: [привязки измерений, которых нет в строке-источнике], key } ; targets [] — каскада нет
// IE 2026 10 18 / ODOO-5800 (бот на TEST 1ot9_002: у строк-документов dims нет — грид 1coh_001 дерево БЮ → Бренд → Сводная номенклатура → документ, измерение лежит на СТРОКЕ ГРУППЫ:
// условие _DLRow.where [{leftValue.value: 'doc.БЮ', condition: '=', rightValue.value: id}] либо значение в её dataItem): значение измерения строки — своё, иначе по предкам
// (ближайший выше по дереву, с меньшим level), сначала условие where, затем значение dataItem предка. Предки — стек строк с меньшим level, набранный одним проходом по rows
function whereValue(x, b) {
    const dl = isObj(x) ? x._DLRow : null, w = dl && Array.isArray(dl.where) ? dl.where : null
    if (!w) return undefined
    const c = w.find(c => isObj(c) && isObj(c.leftValue) && str(c.leftValue.value) === b && (c.condition === undefined || str(c.condition) === '='))
    return c ? (isObj(c.rightValue) ? c.rightValue.value : c.rightValue) : undefined
}
// null — тоже «нет поля»: AttrGrid.fmtGetValue / store.get_value отдают null за отсутствующее поле строки (и '' → '' сравнялось бы у всех строк — каскад «на всё»)
const absent = (v) => v === undefined || v === null
function dimOf(x, anc, b, read) {
    let v = read(x, b)
    if (!absent(v)) return v
    for (let j = anc.length - 1; j >= 0; j--) {
        v = whereValue(anc[j].dataItem, b)
        if (!absent(v)) return v
        v = read(anc[j].dataItem, b)
        if (!absent(v)) return v
    }
    return undefined
}
// предки строки irow: индексы строк выше с убывающим level (ближайший — последний)
function ancestorIdx(rows, irow) {
    const anc = []
    let l = lvl(rows[irow])
    for (let i = irow - 1; i >= 0 && l > 0; i--) { const r = rows[i]; if (r && lvl(r) < l) { anc.unshift(i); l = lvl(r) } }
    return anc
}
function ancestorsOf(rows, irow) { return ancestorIdx(rows, irow).map(i => rows[i]) }
// IE 2026 10 18 / ODOO-5800 (дефект после PR #131: SKU-строка «M% (1.2)» STR 2028 с ПМ — БЮМ не ставился «потребує погодження ПМ по всьому бренду», а родительская птичка ПМ бренда полная):
// ключ отбора строки БЕЗ условий по type_calc (строка M% несёт type_calc = 1.2, строка-итог бренда — нет; порядок считается без учёта type_calc)
const KEY_CALC = /(^|[.:])type_calc$/
function keyNoCalc(x) {
    const w = isObj(x) && isObj(x._DLRow) ? x._DLRow.where : null
    if (!Array.isArray(w) || !w.length) return ''
    return approvalRowKey({ _DLRow: { where: w.filter(e => !(isObj(e) && KEY_CALC.test(str(isObj(e.leftValue) ? e.leftValue.value : e.leftValue)))) } })
}
// строка-итог уровня группировки шага для строки irow: ближайший предок, несущий измерение шага (where / dataItem — бренд для БЮМ, БЮ для МД), и среди его ПРЯМЫХ детей —
// строка с тем же ключом меры / года (без type_calc). На ней рисуется родительская птичка (approvalPartialLive). -1 — не найдена
export function m03AggregateTotalRow(rows, irow, binding, read) {
    const dims = m03CascadeDims(binding)
    const R = rows && typeof rows === 'object' ? rows[irow] : null, src = R ? R.dataItem : null
    if (!dims || !src || typeof read !== 'function') return -1
    const srcKey = keyNoCalc(src)
    if (!srcKey) return -1
    const anc = ancestorIdx(rows, irow)
    let gi = -1
    for (let j = anc.length - 1; j >= 0 && gi < 0; j--) { const x = rows[anc[j]].dataItem; if (dims.some(b => !absent(whereValue(x, b)) || !absent(read(x, b)))) gi = anc[j] }
    if (gi < 0) return -1
    const gl = lvl(rows[gi])
    for (let i = gi + 1; i < rows.length; i++) {
        const r = rows[i]
        if (lvl(r) <= gl) break
        if (lvl(r) !== gl + 1) continue
        const x = r ? r.dataItem : null
        if (!x || skipRow(x)) continue
        if (keyNoCalc(x) === srcKey) return i
    }
    return -1
}
export function m03CascadeTargets(rows, irow, binding, read, opts) {
    const o = isObj(opts) ? opts : {}
    const out = { targets: [], missingDims: [], key: '' }
    if (!rows || typeof rows !== 'object' || !(rows.length >= 0) || typeof read !== 'function') return out
    const dims = Array.isArray(o.dims) ? o.dims : m03CascadeDims(binding)
    if (!dims || !dims.length) return out
    const R = rows[irow], src = R ? R.dataItem : null
    if (!src || skipRow(src)) return out
    const key = approvalRowKey(src)
    if (!key) return out
    out.key = key
    const srcId = recId(src)
    if (srcId === null) return out   // источник — не строка-документ (итог / заголовок группы): клик по итогу остаётся кликом по итогу, каскада нет
    const want = []
    const srcAnc = ancestorsOf(rows, irow)   // IE 2026 10 18 / ODOO-5800: измерения — по предкам дерева
    for (const b of dims) { const v = m03DimValue(dimOf(src, srcAnc, b, read)); if (v === undefined) out.missingDims.push(b); else want.push({ b, v }) }
    if (!want.length) return out   // ни одного измерения в строке нет — каскад «на всё» не делается
    const clear = o.clear === true   // IE 2026 10 18 / ODOO-5800: симметрия — снятие
    const all = o.all === true   // IE 2026 10 18 / ODOO-5800 (порядок по агрегату): все строки-документы набора измерений, без учёта значения флажка и порядка
    const lower = !clear && !all && Array.isArray(o.lower) ? o.lower : []
    const upper = clear && !all && Array.isArray(o.upper) ? o.upper : []
    const byId = new Map()   // record_id → самая глубокая строка документа
    const stack = []   // IE 2026 10 18 / ODOO-5800: предки текущей строки (level строго растёт)
    for (let i = 0; i < rows.length; i++) {
        const r = rows[i], x = r ? r.dataItem : null
        const l = lvl(r)
        while (stack.length && lvl(stack[stack.length - 1]) >= l) stack.pop()
        const anc = stack.slice()
        if (r) stack.push(r)
        if (i === irow) continue
        if (!x || skipRow(x)) continue
        const rid = recId(x)
        if (rid === null || rid === srcId) continue
        if (approvalRowKey(x) !== key) continue
        let same = true
        for (const d of want) if (m03DimValue(dimOf(x, anc, d.b, read)) !== d.v) { same = false; break }
        if (!same) continue
        const cur = byId.get(rid)
        if (!cur || l >= cur.l) byId.set(rid, { l, i, x })
    }
    for (const d of byId.values()) {
        if (!all && m03FlagTrue(read(d.x, binding)) !== clear) continue   // IE 2026 10 18 / ODOO-5800: установка — пропустить уже стоящие, снятие — уже снятые
        let ok = true
        for (const lb of lower) if (!m03FlagTrue(read(d.x, lb))) { ok = false; break }
        for (const ub of upper) if (m03FlagTrue(read(d.x, ub))) { ok = false; break }
        if (!ok) continue
        if (typeof o.canSet === 'function' && !o.canSet(d.x, d.i)) continue
        out.targets.push({ irow: d.i, dataItem: d.x })
    }
    out.targets.sort((a, b) => a.irow - b.irow)
    return out
}
// ячейка флажка заперта бэком (мета строки / ячейки _DLRow) — каскад её не трогает
export function m03CellLocked(dataItem, binding) {
    const dl = isObj(dataItem) ? dataItem._DLRow : null
    if (!isObj(dl)) return false
    if (dl.isReadOnly === true) return true
    const c = isObj(dl.cells) ? dl.cells[binding] : null
    return isObj(c) && c.isReadOnly === true
}

// IE 2026 10 18 / ODOO-5800 (Igor, скрин: родительская строка бренда STR 2029 с ЧАСТИЧНЫМ ПМ (36.6), а на SKU-строке 74.7 удалось поставить БЮМ): порядок шагов считается по
// АГРЕГАТУ измерения шага, а не по своей строке — БЮМ разрешён, только если ApprovedPM стоит на ВСЕХ загруженных строках-документах того же БЮ + бренд (+ страна) с той же
// мерой и годом (родительская птичка ПМ полная); МД — только если ApprovedBUM стоит на всех строках той же БЮ (та же мера / год). Набор строк агрегата — те же цели каскада
// (m03CascadeTargets, all: true) + сама строка. lower — привязки шагов ниже (m03LowerBindings). ПМ (измерений каскада нет) / шагов ниже нет — ok.
// → { ok, missing: [привязки шагов ниже, не стоящие хотя бы на одной строке агрегата], rows: число строк агрегата, missingDims }
// IE 2026 10 18 / ODOO-5800 (дефект после PR #131, Igor: набор строк проверки ≠ набору родительской птички): набор строк агрегата — РОВНО набор документов родительской птички
// того же уровня группировки (approvalPartialLive над строкой-итогом m03AggregateTotalRow: бренд для БЮМ, БЮ для МД; без type_calc, незагруженные измерения не участвуют);
// out.total — индекс строки-итога. Итога нет (плоский список без групп) — прежний набор по измерениям (цели каскада all + своя строка)
export function m03AggregateOrder(rows, irow, binding, read, lower) {
    const out = { ok: true, missing: [], rows: 0, missingDims: [], total: -1 }
    if (!Array.isArray(lower) || !lower.length || !m03CascadeDims(binding)) return out
    const R = rows && typeof rows === 'object' ? rows[irow] : null, src = R ? R.dataItem : null
    if (!src || typeof read !== 'function') return out
    const t = m03AggregateTotalRow(rows, irow, binding, read)
    if (t >= 0) {
        out.total = t
        for (const lb of lower) {
            const p = approvalPartialLive(rows, t, lb, read)
            out.rows = p ? p.total : 1
            if (p ? p.approved !== p.total : !m03FlagTrue(read(src, lb))) out.missing.push(lb)
        }
        out.ok = !out.missing.length
        return out
    }
    const agg = m03CascadeTargets(rows, irow, binding, read, { all: true })
    const members = [src, ...agg.targets.map(t => t.dataItem)]
    out.rows = members.length
    out.missingDims = agg.missingDims
    for (const lb of lower) if (!members.every(x => m03FlagTrue(read(x, lb)))) out.missing.push(lb)
    out.ok = !out.missing.length
    return out
}
// текст отказа по агрегату (UI по-английски; перевод — словари uk / ru) по полю флажка; '' — поле без правила агрегата
export const M03_AGG_ORDER_TEXT = {
    ApprovedBUM: '{title}: BUM approval requires PM approval of the whole brand',
    ApprovedMD: '{title}: MD approval requires BUM approval of the whole business unit',
}
export function m03AggregateOrderText(binding) { return M03_AGG_ORDER_TEXT[m03FlagField(binding)] || '' }
